/* @flow */
import React from 'react';

import RequireSetup from '../utils/RequireSetup';

const SetupDefaultView = React.createClass({
  mixins: [
    RequireSetup,
  ],

  // This component will always redirect, hence nothing to render
  render() {
    return null;
  },
});

export default SetupDefaultView;



// WEBPACK FOOTER //
// ./src/setup/components/SetupDefaultView.jsx